import SchemasTable from '../../components/schemas_table'

const Schemas = ({ airlineID }) => {
  return <SchemasTable queryKey={`schemas?airlineID=${airlineID}`} />
}

export default Schemas
